import React from "react";
import { Col, Row, Tabs } from "antd";
import PersonalInfoForm from "./PersonalInfoForm";
import WorkInfoForm from "./WorkInfoForm";
import type { LocationType, DepartmentType } from "./types";
import ContactInfoForm from "./ContactInfoForm";
import { EmployeeDetails } from "../../../serviceoperation/entity/EmployeeOperationEntity";
import BranchAccess from "./BranchAccess";
import SyncSettingsForm from "./SyncSettingsForm";

interface Props {
  form: any;
  initialValues: Record<string, unknown> | undefined;
  isEditing: boolean;
  locations: LocationType[];
  employee: EmployeeDetails | null;
}

const EmployeeTabs: React.FC<Props> = ({
  form,
  initialValues,
  isEditing,
  locations,
  employee,
}) => {
  return (
    <Tabs defaultActiveKey="1" style={{ marginTop: 16 }}>
      <Tabs.TabPane tab="Profile" key="1">
        <Row gutter={24} style={{ marginBottom: 16 }}>
          <Col xs={24} lg={12}>
            <PersonalInfoForm
              employee={employee}
              form={form}
              initialValues={initialValues}
              isEditing={isEditing}
            />
          </Col>
          <Col xs={24} lg={12}>
            <WorkInfoForm
              employee={employee}
              form={form}
              locations={locations}
              isEditing={isEditing}
            />
          </Col>
        </Row>
        <ContactInfoForm form={form} isEditing={isEditing} />
        <SyncSettingsForm form={form} isEditing={isEditing} />
      </Tabs.TabPane>

      <Tabs.TabPane tab="Branch Access" key="2">
        <BranchAccess employeez={employee} />
      </Tabs.TabPane>

      <Tabs.TabPane tab="Payroll" key="3">
        {/* Placeholder: your payroll component goes here. Keep it separate file PayrollTab.tsx */}
        <div style={{ padding: 16 }}>
          Payroll information will live here (add PayrollTab.tsx)
        </div>
      </Tabs.TabPane>

      <Tabs.TabPane tab="Preferences" key="4">
        {/* Placeholder: employee preferences */}
        <div style={{ padding: 16 }}>
          Manage employee preferences here (add PreferencesTab.tsx)
        </div>
      </Tabs.TabPane>
    </Tabs>
  );
};

export default EmployeeTabs;
